import { Route, Redirect } from 'react-router-dom';
import { tokenUtils } from '../utils';

function PrivateRoute({ children, ...rest }) {
  const isLoggedIn = !!tokenUtils.getToken();
  return (
    <Route {...rest}>
      {isLoggedIn ? (
        children
      ) : (
        <Redirect
          to={{
            pathname: '/login',
          }}
        />
      )}
    </Route>
  );
}

export default PrivateRoute;
